module.exports = __webpack_public_path__ + "img/l200_out.618e9bf6.jpg";